import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("jp_token")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      if (e?.response?.status === 403) toast.error(e.response.data.detail);
      localStorage.removeItem("jp_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = (token, u) => { localStorage.setItem("jp_token", token); setUser(u); };
  const logout = () => { localStorage.removeItem("jp_token"); setUser(false); };
  const updateUser = useCallback((p) => setUser((u) => (u ? { ...u, ...(typeof p === "function" ? p(u) : p) } : u)), []);

  return <AuthCtx.Provider value={{ user, login, logout, refresh, updateUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
